import { css } from '@emotion/css';

const wrapper = css({
  '&.MuiBox-root': {
    maxWidth: '480px',
    margin: '0 auto',
  },
});

const container = css({
  '&.MuiBox-root': {
    marginTop: '3rem',
    display: 'flex',
    justifyContent: 'center',
  },
});

const ApproveBeneficiaryComponentStyle = {
  wrapper,
  container,
};

export default ApproveBeneficiaryComponentStyle;
